import React from 'react';
import '../style/Teaching.scss';
// react bootstrap
import { Container } from 'react-bootstrap';
import Header from '../components/public/Header';

function Teaching4() {
  return (
    <>
      <Header />
      <Container>
        <div className='content'>
          <h3 className='text-left text-secondary'>拙火</h3>
          <p className='chineseParagraph'>
            拙火Tummo屬於無上瑜伽部, "Tum 是本俱的意思", "mo是指生起智慧的母親''
            。以此智慧之火“焚燒不淨之蘊界，根除煩惱愚癡”，“成就樂空俱生智慧，獲得雙運金剛持果位”。
            我們自然會在臍脈輪下方的區域內充滿這種智慧之火的溫暖,但我們通常並不了解它，因此我們不使用它。當我們建立適當的專注力並開始使用內心的力量時,我們可以完全改變自己。
            運用觀想,呼吸和動作，我們可以連接到內部火源並使其越來越強大。
            我們屏住呼吸，使一呼一吸的時間更延長，這改變了我們的血液使其更加暖熱。這種溫暖的血液反過來會影響我們的荷爾蒙。我們在學術上討論的並不多，但是當我們種植Tummo火併將其傳播到全身時，我們可以體驗到提高代謝及免疫力等深刻的變化。這不僅是觀想，而且是真實的東西。現代人的環境及壓力造成諸如憂鬱症等精神疾病及細胞各種發炎反應,學習運用拙火的能力可以有實質的幫助
            從物理上講，人體的溫度是透過消化系統和新陳代謝系統所產生，拙火是促進化學反應和生成激素的熱量。在人體正常的基礎上，拙火通過脈的通道來燃燒，融化了微細的負面障礙物，並在整個身體中湧動著正能量。在精神層面上，拙火就是喜悅,愛,幸福及樂的源泉。
            隨著火焰的增長，從肚臍以下開始,拙火輕柔的生起並越來越高的滲透到每個主要的脈輪中，且蔓延到人體的所有支分脈及每個毛孔。
            脈輪是通往我們存在的秘密之門。打開它並開啟我們內在的智慧。從這種偉大的存在中,我們可以認識到人類思想的本質，智慧以及無條件的愛與悲心。
            PS.修練拙火必定要由具格上師處領受指引,不可自行看書面文字而妄加修練
          </p>
        </div>
      </Container>
    </>
  );
}

export default Teaching4;
